import { OpportunityStageEnum } from '../enums/opportunity-stage-enum';

export class OpportunityStage {

  public static OPPSTG_ClosedWonKey = '9141E894-F3FA-481F-9A33-35CB02F31049'; // closed won key
  public static OPPSTG_ClosedUnqualifiedKey = 'E2446E2E-82AA-4AFA-BED7-1D7288D289B3'; // closed unqualified
  public static OPPSTG_ClosedProDeclineKey = 'F3A97BAB-7823-499D-95B3-93F311613F39'; // closed protiviti declined
  public static OPPSTG_ClosedLostKey = '669B4ECC-BF33-47BB-9496-DF8C8AD52441'; // closed lost
  public static OPPSTG_PotentialOppIdentifiedKey = 'B5A282F8-1FBE-44A1-A217-DA8122B7D788'; // Potential Opportunities Identified
  public static OPPSTG_OpportunityQualified ='17C803DC-4E46-41B1-8DD5-B4BAB29C1FA4'; // Opportunities Identified
  public static OPPSTG_ProposedApproachKey = '80AB915A-CAE2-4E11-AFD9-0CA530BF865E'; // Proposed Approach/Pricing
  public static OPPSTG_ClientNegReviewKey = 'C2441F5D-41E4-4288-BE1C-180EAB865412'; // Client Negotiation/Review

  getOpportunityStage(stageId: string): OpportunityStageEnum | void {
    if (!stageId) {
      return OpportunityStageEnum.PotentialOppIdentified;
    }
    const upStageId = stageId.toUpperCase();
    switch (upStageId) {
      case OpportunityStage.OPPSTG_ClosedWonKey:
        return OpportunityStageEnum.ClosedWon;
      case OpportunityStage.OPPSTG_ClosedUnqualifiedKey:
        return OpportunityStageEnum.ClosedUnqualified;
      case OpportunityStage.OPPSTG_ClosedProDeclineKey:
        return OpportunityStageEnum.ClosedProDecline;
      case OpportunityStage.OPPSTG_ClosedLostKey:
        return OpportunityStageEnum.ClosedLost;
      case OpportunityStage.OPPSTG_PotentialOppIdentifiedKey:
        return OpportunityStageEnum.PotentialOppIdentified;
      case OpportunityStage.OPPSTG_OpportunityQualified:
        return OpportunityStageEnum.OppQualified;
      case OpportunityStage.OPPSTG_ProposedApproachKey:
        return OpportunityStageEnum.ProposedApproach;
      case OpportunityStage.OPPSTG_ClientNegReviewKey:
        return OpportunityStageEnum.ClientNegReview;
      default:
        break;
    }
  }

  isOppStageClosed(stageId: string): boolean {
    return (
      stageId === OpportunityStage.OPPSTG_ClosedWonKey ||
      stageId === OpportunityStage.OPPSTG_ClosedUnqualifiedKey ||
      stageId === OpportunityStage.OPPSTG_ClosedProDeclineKey ||
      stageId === OpportunityStage.OPPSTG_ClosedLostKey
    );
  }
}
